import { kuiperClassNames, WithTooltip, Button } from '@opallabs/kuiper'
import { AnalyticsLayer } from '@opallabs/quanta'
import { containerStyles, getButtonStyles } from './styles'
import { Props } from './types'

export const AccountMenuFooter: React.FC<Props> = ({
  openAccountCreator,
  accountTerm,
  canCreateAccount,
  tooltipText,
}) => {
  const onClick = () => {
    openAccountCreator()
    // Popover remains visible until another outside element is clicked
    const outsideElement = document.querySelector(
      '.postMetaBucket'
    ) as HTMLElement
    outsideElement.click()
  }
  return (
    <div className={kuiperClassNames('add-account')} css={containerStyles}>
      <AnalyticsLayer name="Create Account Button">
        <WithTooltip
          className="create-new-from-post"
          disabled={canCreateAccount}
          tooltipOptions={{
            position: 'top',
          }}
          content={tooltipText}
        >
          <Button
            icon="gem-add"
            iconOptions={{
              system: 'gem',
              style: { paddingRight: '4px' },
            }}
            style={getButtonStyles(!canCreateAccount)}
            disabled={!canCreateAccount}
            label={`Add New ${accountTerm}`}
            onClick={onClick}
            size="medium"
          />
        </WithTooltip>
      </AnalyticsLayer>
    </div>
  )
}
